import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Play with the rear volume value to see its effect on the response curve and the directivity pattern.  The optimal value is the one that allows to obtain a cardioid directivity.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0417/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
